import { defaultServiceLanguage } from "@albertine/i18n";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "./resources";

void i18n.use(initReactI18next).init({
    fallbackLng: defaultServiceLanguage,
    pluralSeparator: "#",
    keySeparator: ".",
    nsSeparator: "=", // Tags are using the default namespace separator : so this need to be overridden
    resources,
    interpolation: {
        escapeValue: false, // React already safes from xss
    },
});

export default i18n;
